import styled from 'styled-components';

export const PageLoadingStyle = styled.div`
  background-color: #fff;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  border-radius: 4px;
  box-shadow: 0px 12px 24px 0px rgba(18, 38, 63, 0.03);
  min-height: 580px;

  .card-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 32px;
    width: 384px;
    border-radius: 8px;
    border: 1px solid #edf2f7;

    p {
      margin: 0 !important;
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      color: #4a5568;
    }

    span {
      text-align: center;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: #718096;
    }
  }

  button {
    border: none !important;
    width: 174px;
    height: 40px;
  }

  .btn-primary {
    background-color: #556ee6;
    color: #ffffff;
  }
  .btn-primary:hover {
    background-color: #4753c2;
    color: #ffffff;
  }

  .btn-success {
    background-color: #34c38f;
    color: #ffffff;
  }
  .btn-success:hover {
    background-color: #28a745;
    color: #ffffff;
  }

  .btn-danger {
    background-color: #f56565;
    color: #ffffff;
  }
  .btn-danger:hover {
    background-color: #e53e3e;
    color: #ffffff;
  }
`;
